import React from 'react';
import Sidebar from './Sidebar';
import { Card, Col, Container, Row, Button } from 'react-bootstrap';
import DashboardHeader from './directives/DashboardHeader';
import './css/Dashboard.css';
import './css/Custom.css';
import DataTable from 'react-data-table-component';

const Dashboard = ({ special, clearModalData }) => {
  return (
    <>
      <div
        className="w-100 d-grid"
        style={{ minHeight: '100vh', overflow: 'hidden' }}
      >
        <div className="d-flex  w-100 h-100">
          <div
            className="position-relative"
            style={{ borderRight: '1px solid rgba(255, 255, 255, 0.15)' }}
          >
            <Sidebar special={special} clearModalData={clearModalData} />
          </div>

          <div className="w-100" style={{ height: '100%' }}>
            <DashboardHeader />
            <div className="main-panel">
              <div
                className="content-wrapper px-4 px-lg-4"
                style={{
                  // padding: "15px",
                  flex: '1',
                  backgroundColor: '#00021F',
                  color: '#ffffff',
                  height: '100%',
                  overflowY: 'auto',
                }}
              >
                <div className="heading py-4">
                  <h5 className="mb-0">Dashboard</h5>
                </div>
                <Row className="gy-3">
                  <Col xxl={8} xl={7} lg={12} md={12} sm={12} className="mb-4">
                    <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex">
                      <Card.Body className="p-0">
                        <div className="d-sm-flex gap-3 align-items-center">
                          <div className="p-3 d-icon text-center">
                            <img
                              src="assets/images/utxIcon.png"
                              className=""
                              alt=""
                              width={`138px`}
                              height={`138px`}
                            />
                          </div>
                          <div className="box-content p-3">
                            <h5 className="text-white mb-xxl-4 lh-base">
                              Welcome to your new and Improved Dashboard
                            </h5>

                            <p className="mb-0 text-light-grey small">
                              UNITRONIX believe all project stakeholders are as
                              important as each other. Investment funds and
                              communities should work side by side on projects,
                              on the same terms, towards the same goals.
                            </p>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                    <div className="heading py-4">
                      <h5 className="mb-0">
                        <span className="me-2">
                          <img
                            src="assets/images/utxIcon.png"
                            className=""
                            alt=""
                            width={`32px`}
                            height={`32px`}
                          />
                        </span>
                        My Staked Projects
                      </h5>
                    </div>

                    <Card className="dashboard-card dash-gradient2 overflow-hidden d-flex mb-sm-4">
                      <Card.Body className="">
                        <div className="p-sm-4 text-center">
                          <p className="mb-0 text-light-grey mb-4 small lh-base">
                            You have not staked into any Unitronix Projects
                          </p>
                          <Button
                            variant="primary-gradient"
                            className="border-0"
                          >
                            View Unitronix Projects
                          </Button>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>

                  <Col xxl={4} xl={5} lg={12} md={12} sm={12} className="mb-4">
                    <Card className="dashboard-card dash-gradient2 p-3 d-flex overflow-hidden gap-3 bgparticle">
                      <Card.Body className="p-0">
                        <div className="socialmedia d-flex gap-3 justify-content-center align-items-center">
                          <div className="text-center">
                            <h5 className="text-white lh-base">
                              Stay on top of the game with updates from
                              Unitronix
                            </h5>
                            <p className="text-light-grey py-2 small">
                              Follow us on your Channel of Choice
                            </p>
                            <div className="socialIcon">
                              <a href="#" className="twitter me-3">
                                <img
                                  src="assets/images/dashboard/icon/twitter.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="telegram me-3">
                                <img
                                  src="assets/images/dashboard/icon/telegram.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="medium me-3">
                                <img
                                  src="assets/images/dashboard/icon/medium.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="discord me-3">
                                <img
                                  src="assets/images/dashboard/icon/discord.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                              <a href="#" className="substack">
                                <img
                                  src="assets/images/dashboard/icon/substack.png"
                                  height={`28px`}
                                  width={`28px`}
                                  className="object-fit-contain"
                                />
                              </a>
                            </div>
                          </div>
                        </div>
                      </Card.Body>
                    </Card>
                  </Col>
                </Row>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
